import React from 'react';

const AutoUpgradeNudgeImage = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0)">
      <rect fill="white" height="280" width="410" />
      <g clipPath="url(#clip1)">
        <rect
          fill="#4289F7"
          height="280"
          transform="matrix(-1 0 0 1 410 0)"
          width="412"
        />
      </g>
      <g filter="url(#filter0_d)">
        <path
          d="M36.1309 94.2014C36.1309 88.0997 41.0773 83.1533 47.1789 83.1533H363.952C370.053 83.1533 375 88.0997 375 94.2014V186.384C375 192.486 370.053 197.432 363.952 197.432H47.179C41.0773 197.432 36.1309 192.486 36.1309 186.384V94.2014Z"
          fill="white"
        />
      </g>
      <rect
        height="20.0273"
        rx="10.0136"
        stroke="#CCCCCC"
        strokeDasharray="3.73 3.73"
        strokeWidth="1.40005"
        transform="matrix(1 0 0 -1 55.9727 161.907)"
        width="278.742"
        x="0.700025"
        y="-0.700025"
      />
      <path
        d="M55.9727 152.196C55.9727 158.332 60.947 163.307 67.0831 163.307H247.259V141.086H67.0831C60.947 141.086 55.9727 146.06 55.9727 152.196V152.196Z"
        fill="#FFC43E"
      />
      <path
        d="M247.23 131.388L247.23 173.755"
        stroke="#CCCCCC"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.40005"
      />
      <path
        d="M69.2514 125.167H66.7083V115.29H63.4516V113.174H72.5081V115.29H69.2514V125.167ZM79.9815 125.167L79.4975 123.92H79.4318C79.0107 124.451 78.5759 124.82 78.1275 125.028C77.6845 125.23 77.1048 125.331 76.3884 125.331C75.5079 125.331 74.8133 125.079 74.3047 124.576C73.8015 124.073 73.55 123.357 73.55 122.427C73.55 121.454 73.8891 120.737 74.5672 120.278C75.2508 119.813 76.279 119.556 77.6517 119.507L79.2431 119.457V119.055C79.2431 118.126 78.7673 117.661 77.8158 117.661C77.0829 117.661 76.2216 117.882 75.2317 118.325L74.4031 116.635C75.4586 116.083 76.629 115.807 77.9142 115.807C79.1447 115.807 80.0881 116.075 80.7444 116.611C81.4006 117.147 81.7288 117.962 81.7288 119.055V125.167H79.9815ZM79.2431 120.918L78.2751 120.95C77.5478 120.972 77.0063 121.104 76.6509 121.344C76.2954 121.585 76.1176 121.951 76.1176 122.443C76.1176 123.149 76.5223 123.502 77.3318 123.502C77.9115 123.502 78.3736 123.335 78.7181 123.001C79.0681 122.668 79.2431 122.225 79.2431 121.672V120.918ZM90.7115 122.443C90.7115 123.384 90.3834 124.101 89.7271 124.593C89.0763 125.085 88.1001 125.331 86.7985 125.331C86.1313 125.331 85.5625 125.285 85.0922 125.192C84.6219 125.104 84.1816 124.973 83.7714 124.798V122.731C84.2363 122.949 84.7586 123.133 85.3383 123.28C85.9235 123.428 86.4375 123.502 86.8805 123.502C87.7884 123.502 88.2423 123.239 88.2423 122.714C88.2423 122.517 88.1821 122.359 88.0618 122.238C87.9415 122.113 87.7337 121.973 87.4384 121.82C87.143 121.661 86.7493 121.478 86.2571 121.27C85.5516 120.975 85.032 120.702 84.6984 120.45C84.3703 120.198 84.1296 119.911 83.9765 119.589C83.8289 119.261 83.755 118.859 83.755 118.383C83.755 117.568 84.0695 116.939 84.6984 116.496C85.3328 116.048 86.2297 115.823 87.3891 115.823C88.4939 115.823 89.5685 116.064 90.6131 116.545L89.8584 118.35C89.399 118.153 88.9697 117.992 88.5704 117.866C88.1712 117.74 87.7638 117.677 87.3481 117.677C86.6098 117.677 86.2407 117.877 86.2407 118.276C86.2407 118.5 86.3582 118.694 86.5934 118.859C86.834 119.023 87.3563 119.266 88.1603 119.589C88.8767 119.879 89.4017 120.149 89.7353 120.401C90.0689 120.652 90.315 120.942 90.4736 121.27C90.6322 121.599 90.7115 121.99 90.7115 122.443ZM95.0675 120.179L96.1586 118.785L98.7263 115.996H101.548L97.9059 119.974L101.77 125.167H98.8821L96.2406 121.451L95.166 122.312V125.167H92.6639V112.402H95.166V118.096L95.0347 120.179H95.0675ZM107.643 125.167V113.174H110.186V123.067H115.051V125.167H107.643ZM116.839 113.625C116.839 112.81 117.293 112.402 118.201 112.402C119.109 112.402 119.563 112.81 119.563 113.625C119.563 114.013 119.448 114.317 119.218 114.535C118.994 114.749 118.655 114.855 118.201 114.855C117.293 114.855 116.839 114.445 116.839 113.625ZM119.448 125.167H116.946V115.996H119.448V125.167ZM130.293 125.167H127.791V119.81C127.791 119.148 127.679 118.653 127.455 118.325C127.236 117.992 126.889 117.825 126.413 117.825C125.773 117.825 125.308 118.06 125.018 118.53C124.728 119.001 124.583 119.775 124.583 120.852V125.167H122.081V115.996H123.993L124.329 117.169H124.469C124.715 116.748 125.07 116.419 125.535 116.184C126 115.944 126.533 115.823 127.135 115.823C128.507 115.823 129.437 116.272 129.924 117.169H130.145C130.391 116.742 130.752 116.411 131.228 116.176C131.709 115.941 132.251 115.823 132.852 115.823C133.892 115.823 134.676 116.091 135.207 116.627C135.743 117.158 136.011 118.011 136.011 119.187V125.167H133.501V119.81C133.501 119.148 133.388 118.653 133.164 118.325C132.945 117.992 132.598 117.825 132.122 117.825C131.51 117.825 131.05 118.044 130.744 118.481C130.443 118.919 130.293 119.613 130.293 120.565V125.167ZM138.48 113.625C138.48 112.81 138.934 112.402 139.842 112.402C140.75 112.402 141.204 112.81 141.204 113.625C141.204 114.013 141.089 114.317 140.859 114.535C140.635 114.749 140.296 114.855 139.842 114.855C138.934 114.855 138.48 114.445 138.48 113.625ZM141.089 125.167H138.587V115.996H141.089V125.167ZM147.586 123.338C148.023 123.338 148.548 123.242 149.161 123.051V124.913C148.537 125.192 147.772 125.331 146.864 125.331C145.863 125.331 145.133 125.079 144.674 124.576C144.22 124.068 143.993 123.308 143.993 122.296V117.874H142.795V116.816L144.173 115.979L144.895 114.043H146.495V115.996H149.062V117.874H146.495V122.296C146.495 122.651 146.593 122.914 146.79 123.083C146.992 123.253 147.258 123.338 147.586 123.338Z"
        fill="black"
      />
      <g opacity="0.25">
        <g filter="url(#filter1_d)">
          <path
            d="M36.1309 -39.9519C36.1309 -46.0536 41.0773 -51 47.1789 -51H363.952C370.053 -51 375 -46.0536 375 -39.9519V52.2309C375 58.3326 370.053 63.279 363.952 63.279H47.179C41.0773 63.279 36.1309 58.3326 36.1309 52.2309V-39.9519Z"
            fill="white"
          />
        </g>
      </g>
      <g opacity="0.25">
        <g filter="url(#filter2_d)">
          <path
            d="M36.1309 228.356C36.1309 222.254 41.0773 217.308 47.1789 217.308H363.952C370.053 217.308 375 222.254 375 228.356V320.539C375 326.64 370.053 331.587 363.952 331.587H47.179C41.0773 331.587 36.1309 326.64 36.1309 320.539V228.356Z"
            fill="white"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="136.375"
        id="filter0_d"
        width="360.965"
        x="25.0828"
        y="77.6293"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5.52404" />
        <feGaussianBlur stdDeviation="5.52404" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="136.375"
        id="filter1_d"
        width="360.965"
        x="25.0828"
        y="-56.524"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5.52404" />
        <feGaussianBlur stdDeviation="5.52404" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="136.375"
        id="filter2_d"
        width="360.965"
        x="25.0828"
        y="211.784"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5.52404" />
        <feGaussianBlur stdDeviation="5.52404" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <clipPath id="clip0">
        <rect fill="white" height="280" width="410" />
      </clipPath>
      <clipPath id="clip1">
        <rect
          fill="white"
          height="280"
          transform="matrix(-1 0 0 1 410 0)"
          width="412"
        />
      </clipPath>
    </defs>
  </svg>
);

export default AutoUpgradeNudgeImage;
